import CreatePassword from '../../modules/auth/UI/CreatePassword';
import Logo from '../../components/shared/Logo';
import Meta from '../../components/layout/Meta';

import { useTranslation } from 'react-i18next';

function CreatePasswordPage() {
  const { t } = useTranslation();
  const pageTitle = t('auth.create_password_title');

  return (
    <>
      <Meta title={pageTitle} />
      <div className="min-h-screen flex items-center justify-center p-4 sm:p-8">
        <div className="pks-layout-col-xl w-full">
          <Logo isLink={false} className="m-auto" />
          <div className="min-h-[507px]">
            <div className="pks-layout-col-xl max-w-[444px] m-auto p-4 bg-primary-50 rounded-lg sm:p-8">
              <h1 className="h2">{pageTitle}</h1>
              <CreatePassword />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default CreatePasswordPage;
